import React, { Component } from 'react'
import styled from 'styled-components'
import axios from 'axios'
import ReactTable from 'react-table'
import { API_URL } from '../constants'
import { PageWrapper, FlexWrapper, XMText, Checkbox, Modal, SelectBox, Button } from '../components'
import 'react-table/react-table.css'
import { get } from 'lodash'
import { Link } from 'react-router-dom'
import { createGlobalStyle } from 'styled-components'
import moment from 'moment'

const GlobalStyle = createGlobalStyle`
  body>div{
    max-width:100% !important;
  }
`

const TableWrap = styled.div`
  position: relative;
  .ReactTable.-striped.-highlight {
    padding-bottom: 50px;
  }
  .rt-thead.-header {
    background: #078489;
    color: #fff;
  }
  .rt-td {
    white-space: normal !important;
  }
  .pagination-bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #078489;
    color: #fff;
  }
  .ReactTable .-pagination .-btn[disabled] {
    color: #fff;
    opacity: 0.9;
  }
  .ReactTable .-pagination .-btn {
    color: #fff;
  }
  .rt-tbody {
    /* max-height: calc(100vh - 93px); */
  }

  .ReactTable .rt-thead.-filters .rt-th:nth-child(9) > input {
    display: block !important;
  }
  .ReactTable .rt-thead.-filters .rt-th:nth-child(n + 2) > input {
    display: none;
  }
`
class ViewRecallWarning extends Component {
  state = {
    loader: false,
    warningData: [],
    checkedRows: [],
    checkAll: false,
    changeStatusModal: false,
    isSubmitLoading: false,
    selectedOption: null
  }
  componentDidMount() {
    this.getRecallData()
  }

  getRecallData = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/RecallWarnings`)
      this.setState({ warningData: data })
    } catch (error) {
      console.log(error)
    }
  }

  async deleteEntries(id) {
    try {
      await axios.delete(`${API_URL}/RecallWarnings/${id}`)
      this.getRecallData()
    } catch (error) {
      console.log(error)
    }
  }

  checkRow(itemId, checked) {
    if (checked) {
      this.setState({ checkedRows: [...this.state.checkedRows, itemId] })
    } else {
      this.setState({
        checkedRows: this.state.checkedRows.filter(id => id !== itemId),
        checkAll: false
      })
    }
  }

  checkAll(checked) {
    if (checked) {
      this.setState({
        checkAll: true,
        checkedRows: get(this.state, 'warningData', []).map(item => item.id)
      })
    } else {
      this.setState({
        checkedRows: [],
        checkAll: false
      })
    }
  }

  handleChange = selectedOption => {
    this.setState({ selectedOption: selectedOption })
  }

  submitStatus = async () => {
    this.setState({ isSubmitLoading: true })
    try {
      await axios.post(`${API_URL}/RecallWarnings/bulk-approve`, {
        data: { ids: this.state.checkedRows, status: get(this.state.selectedOption, 'value', '') }
      })
      this.setState({ isSubmitLoading: false, changeStatusModal: false, checkedRows: [], checkAll: false })
      this.getRecallData()
    } catch (error) {
      this.setState({ isSubmitLoading: false })
      console.log(error)
    }
  }

  render() {
    const { warningData, changeStatusModal, isSubmitLoading, selectedOption } = this.state
    return (
      <React.Fragment>
        <GlobalStyle />
        <PageWrapper viewPadding="0 20px" height="auto" modifyPadding="0 20px">
          <TableWrap>
            <ReactTable
              data={warningData}
              filterable
              sortable={false}
              defaultFilterMethod={(filter, row) => String(row[filter.id]) === filter.value}
              columns={[
                {
                  Header: 'ID',
                  accessor: 'id',
                  width: 50
                },
                {
                  Header: 'Title',
                  accessor: 'title',
                  width: 250,
                  filterMethod: (filter, row) =>
                    row[filter.id].startsWith(filter.value) && row[filter.id].endsWith(filter.value)
                },
                {
                  Header: 'News Source',
                  accessor: 'newsSource',
                  width: 100
                },
                {
                  Header: 'News Date',
                  accessor: 'newsDate',
                  Cell: row =>
                    row.original.newsDate ? moment(get(row.original, 'newsDate', '')).format('DD MMM YYYY') : '',
                  minWidth: 150
                },
                {
                  Header: 'Type',
                  accessor: 'type',
                  width: 100
                },
                {
                  Header: 'Categories',
                  accessor: 'categories',
                  width: 200
                },
                {
                  Header: 'Products',
                  accessor: 'productNames',
                  Cell: row =>
                    row.original.productNames
                      ? row.original.productNames
                          .split('||')
                          .map(item => item)
                          .join(', ')
                      : '',
                  width: 200
                },
                {
                  Header: 'Locations',
                  accessor: 'locations',
                  width: 300
                },
                {
                  Header: row => {
                    return (
                      <React.Fragment>
                        <div>
                          Current Status
                          <Checkbox
                            flip
                            label="Check All"
                            checked={this.state.checkAll}
                            onChange={checked => this.checkAll(checked)}
                            borderColor="#fff"
                          />
                        </div>
                        {this.state.checkedRows.length > 0 ? (
                          <div
                            style={{ border: '1px solid #fff', borderRadius: 6, padding: 5, marginTop: 4 }}
                            onClick={() => this.setState({ changeStatusModal: true })}>
                            {this.state.checkedRows.length > 0 && <span>Change Status</span>}
                          </div>
                        ) : null}
                      </React.Fragment>
                    )
                  },
                  accessor: 'isActive',
                  Cell: row => (
                    <React.Fragment>
                      <div style={{ position: 'relative' }}>
                        <Checkbox
                          flip
                          label={get(row, 'original.isActive', false) ? 'Live' : 'Dead'}
                          circle={false}
                          checked={this.state.checkedRows.indexOf(get(row.original, 'id', 0)) > -1}
                          onChange={checked => this.checkRow(get(row.original, 'id', 0), checked)}
                        />
                      </div>
                    </React.Fragment>
                  ),
                  filterMethod: (filter, row) => {
                    if (filter.value === 'all') {
                      return true
                    }
                    if (filter.value === 'live') {
                      return row[filter.id] === true
                    }
                    return row[filter.id] === false
                  },
                  Filter: ({ filter, onChange }) => (
                    <select
                      onChange={event => onChange(event.target.value)}
                      style={{ width: '100%' }}
                      value={filter ? filter.value : 'all'}>
                      <option value="all">All</option>
                      <option value="live">Live</option>
                      <option value="dead">Dead</option>
                    </select>
                  ),
                  minWidth: 200
                },
                {
                  Header: 'Publish Date',
                  accessor: 'publishDate',
                  Cell: row =>
                    row.original.publishDate ? moment(get(row.original, 'publishDate', '')).format('DD MMM YYYY') : '',
                  minWidth: 150
                },
                {
                  Header: (
                    <FlexWrapper alignItems="center">
                      <XMText color="#fff">Action</XMText>
                      <Link style={{ color: '#FFF', textDecoration: 'underline' }} to={'/add-recall-warning-native'}>
                        Add
                      </Link>
                    </FlexWrapper>
                  ),
                  Cell: row => (
                    <React.Fragment>
                      <a
                        style={{ color: '#124b5f', textDecoration: 'underline' }}
                        onClick={() => {
                          if (window.confirm('Are you sure?')) this.deleteEntries(row.original.id)
                        }}>
                        Delete
                      </a>
                    </React.Fragment>
                  ),
                  width: 150
                }
              ]}
              defaultPageSize={50}
              // pageSize={5}
              minRows={0}
              resizable={false}
              className="-striped -highlight"
            />
          </TableWrap>
        </PageWrapper>
        <Modal
          title={'Change status'}
          show={changeStatusModal}
          hide={!changeStatusModal}
          style={{ minHeight: 240 }}
          onClose={() => this.setState({ changeStatusModal: false })}>
          <FlexWrapper alignItems="center">
            <SelectBox
              name="status"
              options={[{ value: true, label: 'Live' }, { value: false, label: 'Dead' }]}
              value={selectedOption}
              onChange={this.handleChange}
              selectField
            />
            <Button
              size="small"
              label="Submit"
              volume="filled"
              margin="14px 0 0 0"
              type="submit"
              isLoading={isSubmitLoading}
              disabled={isSubmitLoading}
              onClick={this.submitStatus}
            />
          </FlexWrapper>
        </Modal>
      </React.Fragment>
    )
  }
}
export default ViewRecallWarning



// WEBPACK FOOTER //
// ./src/pages/ViewRecallWarning.js